import {css} from 'lit';
export const styles = css`:host {
  --app-primary-color: #01965f;
  --app-primary-color-400: #017243;

  --app-secondary-color: black;

  --accent-color: var(--google-red-500);
  --accent-color-400: var(--google-red-300);

  --accent-home: var(--google-red-500);
  --accent-home-400: var(--google-red-300);
  --accent-away: var(--google-green-500);
  --accent-away-400: var(--google-green-300);
}`;
export default styles;
